import {API_BASE_URL, PAGINATION_DEFAULT_LIMIT} from "./constants";
import {secureFetch} from "./authService";

export function getLoanOrders(query, lang) {
    let url = API_BASE_URL + '/loan/order?';

    const {
        page = 0,
        size = PAGINATION_DEFAULT_LIMIT,
        retailerId, pointId, filter, status, dateFrom, dateTo, sort
    } = query;

    url += `&lang=${lang}&page=${page}&size=${size}`;
    if (retailerId) url += `&retailerId=${retailerId}`;
    if (pointId) url += `&pointId=${pointId}`;
    if (filter) url += `&filter=${filter}`;
    if (status) url += `&status=${status}`;
    if (dateFrom) url += `&dateFrom=${dateFrom}`;
    if (dateTo) url += `&dateTo=${dateTo}`;
    if (sort) url += `&sort=${sort}`;

    return secureFetch(url, {
        method: 'GET',
    });
}

export function getLoanOrder(orderId, lang) {
    let url = API_BASE_URL + `/loan/order/${orderId}?lang=${lang}`;

    return secureFetch(url, {
        method: 'GET',
    });
}

export function saveLoanOrder(loanOrder, lang) {
    return secureFetch(API_BASE_URL + `/loan/order/create?lang=${lang}`, {
        method: 'POST',
        body: JSON.stringify(loanOrder)
    });
}

export function rejectLoan(orderId, lang) {
    return secureFetch(API_BASE_URL + `/loan/order/${orderId}/reject?lang=${lang}`, {
        method: 'POST',
        body: null
    });
}

export function confirmLoan(orderId, lang) {
    return secureFetch(API_BASE_URL + `/loan/order/${orderId}/confirm?lang=${lang}`, {
        method: 'POST',
        body: null
    });
}

export function returnProduct(orderId, lang, returnRequest) {
    return secureFetch(API_BASE_URL + `/loan/order/${orderId}/return?lang=${lang}`, {
        method: 'POST',
        body: JSON.stringify(returnRequest)
    });
}


// WEBPACK FOOTER //
// ./src/helpers/loanOrderService.js